function redirectAutoFromIp() {
	let countryCode = document.querySelector("body").dataset.country;
  console.log('test', countryCode);

	const currentUrl = window.location.href;

  if (currentUrl.includes("redirect=false") || currentUrl.includes("oseid")) {
		sessionStorage.setItem("no_redirect", "true");
  }
  if (sessionStorage.getItem("no_redirect") == "true" || countryCode === " ") {
		// Do not redirect
  } else {
    // Redirect
    if (countryCode == "ES") {
      window.location.href = "https://www.shapeheart.es/";
    } else if (countryCode == 'CH') {
      window.location.href = "https://shapeheart.ch/";
    }
  }
}
redirectAutoFromIp()
